module.exports = __webpack_public_path__ + "fonts/fa-v2-light-300.4f6e39d6.woff2";